<template>
    <div style="background-color: #fff">
        <MercenaryHeader :title="'알림'" :back-title="'뒤로가기'" :close-action="closeCompleteAction">
            <div @click="() => { isShowPopupMenu = true }" style="padding-right: 12px; display: flex; height: 100%; justify-content: flex-end; gap: 3px; align-items: center; position: relative;">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
            </div>
        </MercenaryHeader>
        <InfinityScroll :is-enable-next-page-handle="isEnableNextPageHandle" :handle-next-page="handleNextPage" :refresh-action="refresh" style="overflow:auto; flex:1;">
            <div style="background-color: #fff;" ref="main_wrapper">
                <div v-if="notReadList.length > 0" style="">
                    <div style="font-weight: 500; padding-left: 12px; padding-bottom: 16px; padding-top: 12px;">읽지 않은 알림</div>
                </div>
                <template v-if="notReadList.length > 0">
                    <div v-for="each, i in notReadList" style="position:relative;" class="row" :class="{ new: each.is_read == '0' }" :key="i + 'not_read'" @click="showDetail(each.idx, each.title, each.refer_idx, i, each.action, each.param1, true); each.title === '스케줄' ? $Util.sendEventClick('gsc_soccerjoin_quit_join_schedule') : ''">
                        <div style="width:40px; display:grid;place-items: center; margin-right: 8px;">
                            <div v-if="each.image_paths && each.image_paths.length > 0">
                                <RoundProfileImage :changeHeight="40" :changeWidth="40" :memberList="each.image_paths"></RoundProfileImage>
                            </div>
                            <img v-else-if="each.image_path" :src="each.image_path ? $resourcePath + each.image_path : require('@/assets/recommend_profile/basic_profile.png')" style=" width: 40px;border-radius: 50%;" @error="(e) => { e.target.src = require('@/assets/recommend_profile/basic_profile.png') }">
                            <div v-else style="border-radius:50%;background-color: #EBEBEB;width:40px; height:40px; display:grid;place-items: center;">
                                <img :src="require('@/assets/img/notice_no_picture.png')" style="width:20px;height:20px;">
                            </div>
                        </div>
                        <div style="flex:1; display: flex; align-items: center; justify-content: space-between;">
                            <div>
                                <div style="font-size:14px; font-weight:bold; color:#210F03;margin-bottom:5px;" v-if="pushActionName[each.action] === '소식'">{{ each.title }}</div>
                                <div style="font-size:14px; color:#210f03; line-height: 24px; font-weight:500; padding-right: 5px;">{{ each.message }}</div>
                                <div style="display: flex; align-items: center; gap: 4px;">
                                    <div style="font-size:12px; color:#606060; line-height: 20px; font-weight: 500;">{{ each.push_date | agoDateStr }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="height: 20px; background-color: #f5f5f5;"></div>
                </template>
                <div style="">
                    <div style="font-weight: 500; padding-left: 12px; padding-top: 12px; padding-bottom: 16px;">모든 알림</div>
                </div>
                <div v-for="each, i in list" style="position:relative;" class="row" :class="{ new: each.is_read == '0' }" :key="i" @click="showDetail(each.idx, each.title, each.refer_idx, i, each.action, each.param1, false); each.title === '스케줄' ? $Util.sendEventClick('gsc_soccerjoin_quit_join_schedule') : ''">
                    <div style="width:40px; display:grid;place-items: center; margin-right: 8px;">
                        <div v-if="each.image_paths && each.image_paths.length > 0">
                            <RoundProfileImage :changeHeight="40" :changeWidth="40" :memberList="each.image_paths"></RoundProfileImage>
                        </div>
                        <img v-else-if="each.image_path" :src="each.image_path ? $resourcePath + each.image_path : require('@/assets/recommend_profile/basic_profile.png')" style=" width: 40px;border-radius: 50%;" @error="(e) => { e.target.src = require('@/assets/recommend_profile/basic_profile.png') }">
                        <div v-else style="border-radius:50%;background-color: #EBEBEB;width:40px; height:40px; display:grid;place-items: center;">
                            <img :src="require('@/assets/img/notice_no_picture.png')" style="width:20px;height:20px;">
                        </div>
                    </div>
                    <div style="flex:1; display: flex; align-items: center; justify-content: space-between;">
                        <div>
                            <div style="font-size:14px; font-weight:bold; color:#210F03; margin-bottom:5px;" v-if="pushActionName[each.action] === '소식'">{{ each.title }}</div>
                            <div style="font-size:14px; color:#210f03; line-height: 24px; font-weight:500;padding-right: 5px;">{{ each.message }}</div>
                            <div style="display: flex; align-items: center; gap: 4px;">
                                <div style="font-size:12px; color:#606060; line-height: 20px; font-weight: 500;">{{ each.push_date | agoDateStr }}</div>
                            </div>
                        </div>
                        <div>
                        </div>
                    </div>
                </div>

                <div style="height:10px;"></div>
            </div>
        </InfinityScroll>
        <BottomPopupMenu :is-open="isShowPopupMenu" :menu-options="menuOptions"></BottomPopupMenu>
    </div>
</template>

<script>
import MercenaryHeader from "../../common/MercenaryHeader";
import InfinityScroll from "../../common/InfinityScroll";
import RoundProfileImage from "@/components/common/RoundProfileImage";
import { MEMBER_TYPE, PUSH_ACTION, PUSH_VIEW_TYPE } from "../../../Constants";
import BottomPopupMenu from '@/components/common/BottomPopupMenu';

export default {
    name: "NoticeAll",
    props: {
        noticeCount: {
            type: Number,
            default: -1,
        },
        setNoticeCount: {
            type: Function,
            default: () => { }
        }
    },
    components: { InfinityScroll, MercenaryHeader, RoundProfileImage, BottomPopupMenu },
    data() {
        return {
            PUSH_VIEW_TYPE: PUSH_VIEW_TYPE,
            MEMBER_TYPE: MEMBER_TYPE,
            isEnableNextPageHandle: true,
            list: [],
            page: 1,
            curIndex: 0,
            images: {
                '자유게시판': require('@/assets/alarm_soccerhow.png'),
                '사커하우': require('@/assets/alarm_soccerhow.png'),
                '구매내역': require('@/assets/alarm_purchase.png'),
                '사커조인참여': require('@/assets/alarm_soccerjoin.png'),
                '사커조인신청': require('@/assets/alarm_soccerjoin.png'),
                '스케줄예약': require('@/assets/reservation.png'),
                '그외': require('@/assets/reservation.png'),
            },
            count: 0,
            isShowSettingMenu: false,
            memberList: [],
            notReadList: [],
            isShowPopupMenu: false,
            menuoptions: [],
            isGetAllNotice: false,
            pushActionName: {
                [PUSH_ACTION.JOIN_DETAIL]: '멤버톡',
                [PUSH_ACTION.JOIN_INVITATION_LIST]: '멤버톡',
                [PUSH_ACTION.OPEN_TALK]: '오픈 멤버톡',
                [PUSH_ACTION.PROFILE]: '프로필',
                [PUSH_ACTION.POSITION_PRO]: '소식',
                [PUSH_ACTION.SOCCERHOW_DETAIL]: '하우 피드',
                [PUSH_ACTION.JOIN_SCHEDULE_DETAIL]: '멤버톡',
                [PUSH_ACTION.MY_PAGE]: '기타',
                [PUSH_ACTION.JOIN_TALK]: '멤버톡',
                [PUSH_ACTION.POSITION_DELAY]: '포지션 찾기',
                [PUSH_ACTION.OPEN_SCHEDULE_DETAIL]: '멤버톡',
                [PUSH_ACTION.LESSON_SCHEDULE_DETAIL]: '수업',
                [PUSH_ACTION.MERCENARY_SCHEDULE_DETAIL]: '스케줄',
            }
        }
    },
    methods: {
        async closeCompleteAction() {
            this.$GlobalStore.closeLastModal()
            const res = await this.$Axios.get('/api/my/notice/count');
            this.$GlobalStore.setNoticeCount(res.data.noticeCount);
        },
        showAlarmSetting() {
            this.$GlobalStore.addModal('AlarmManage');
        },
        calcMainWrapperHeight() {
            const mainWrapperHeight = this.$refs.main_wrapper.clientHeight
            const height = window.innerHeight
            const test = height - mainWrapperHeight

            if (test > 50) {
                this.isGetAllNotice = true
                this.page = 1;
                this.getNoticeAll()
            }
        },
        async getNoticeAll() {
            this.isEnableNextPageHandle = false;

            const parameters = { page: this.page };
            parameters.push_view_type = this.curIndex;
            parameters.is_read = 1;
            const res = await this.$Axios.get('/api/my/notice', { params: parameters });
            const list = res.data.noticeList;

            if (list.length > 0) {
                this.list = [...this.list, ...list];
                this.isEnableNextPageHandle = true;
            }
        },
        async getNotReadNotice() {
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.page = this.page;
            parameters.push_view_type = this.curIndex;
            parameters.is_read = 0;
            const res = await this.$Axios.get('/api/my/notice', { params: parameters });
            const notReadList = res.data.noticeList;

            if (notReadList.length > 0) {
                this.notReadList = [...this.notReadList, ...notReadList];
                this.isEnableNextPageHandle = true;
                if (this.page === 1) {
                    this.$nextTick(() => {
                        this.calcMainWrapperHeight()
                    })
                }
            }
            if (notReadList.length === 0) {
                this.isGetAllNotice = true
                this.page = 1;
                this.getNoticeAll()
            }
        },
        handleNextPage() {
            this.page++;
            if (this.isGetAllNotice) {
                this.getNoticeAll();
            } else {
                this.getNotReadNotice();
            }
        },
        showDetail(pushMessageIdx, title, referIdx, index, action, param1, isNotList) {
            this.readNotice(pushMessageIdx);
            window.pushCustomManager.goScreen(title, referIdx, action, param1, '', true);

            if (action == PUSH_ACTION.MY_LOCATION
                || action == PUSH_ACTION.SOCCERHOW_MAIN
                || action == PUSH_ACTION.SOCCERJOIN_MAIN
                || action == PUSH_ACTION.MY_PAGE
                || action == PUSH_ACTION.DIRECT_MESSAGE_LIST
            ) {
                this.$GlobalStore.closeLastModal();
            }

            if (isNotList) {
                const notice_one = window.copyObject(this.notReadList[index]);
                this.$delete(this.notReadList, index);

                let is_inserted = false;

                for (let i = 0; i < this.list.length; i++) {
                    const each = this.list[i];
                    if (each.insert_date <= notice_one.insert_date) {
                        this.list.splice(i, 0, notice_one);
                        is_inserted = true;
                        break;
                    }
                }
                if (!is_inserted) {
                    this.list.push(notice_one);
                }
            }

            if (this.$GlobalStore.noticeCount() !== 0) {
                this.$GlobalStore.setNoticeCount(this.$GlobalStore.noticeCount() - 1)
            }

        },
        async readNotice(idx) {
            const parameters = {};
            parameters.idx = idx;
            const res = await this.$Axios.get('/api/my/readNotice', { params: parameters });
            this.count = res.data.noticeCount;
            // this.setNoticeCount(this.count);
        },
        async readAll() {
            const res = await this.$Axios.post('/api/my/readnoticeall');
            if (res.data.code === 0) {
                this.count = 0;
                this.$GlobalStore.setNoticeCount(0);
                this.refresh();
            }
        },
        refresh() {
            this.isEnableNextPageHandle = true;
            this.page = 1;
            this.list = [];
            this.notReadList = [];
            this.getNotReadNotice();
        },
        setIndex(index) {
            this.curIndex = index;
            this.page = 1;
            this.isEnableNextPageHandle = true;
            this.list = [];
            this.getNoticeAll();
        },

    },
    created() {
        this.readAll = this.$Once(this.readAll);

        this.count = this.noticeCount;

        this.getNotReadNotice()

        this.menuOptions = {
            labelAndAction: [
                { label: '알림 수신 설정', action: () => { this.showAlarmSetting(); this.isShowPopupMenu = false; } },
                { label: '모든 알림 읽음', action: () => { this.readAll(); this.isShowPopupMenu = false; } },
            ],
            isExistCancelBtn: true,
            closeAction: () => {
                this.isShowPopupMenu = false;
            }
        }
    }
}
</script>

<style scoped>
.circle {
    width: 5px;
    height: 5px;
    background-color: #210f03;
    border-radius: 50%;
}

.row {
    padding: 0px 12px 18px 12px;
    display: flex;
}
</style>